import React from 'react';
import { post } from '../../Auths/AuthToken';
import setUiMessage from '../../../Utilities/Tostify';
import Button from '../../Button';
import { useSelector } from 'react-redux';

function IntakeResendPop({ intakeDetail = {}, handleClose, handleReload }) {
  const { user } = useSelector((state) => state.auth);
  const handleIntakeResend = async (id, patId) => {
    try {
      const response = await post('api/patient/intake/resendIntakeForm', {
        intakeId: id,
        patId: patId,
        loginUserId: user?.id,
      });
      if (response.status === 200) {
        if (parseInt(response?.data?.status) === true) {
          setUiMessage('suc', 'Intake form has been sent successfully.');
        } else {
          setUiMessage('err', response?.data?.message);
        }
        handleReload();
        handleClose();
      }
    } catch (err) {
      setUiMessage('err', err.message);
    }
  };
  return (
    <div className="modalBackground">
      <div className="claim-bill-note-con shadow">
        <div className="width100">
          <div className="pmsPopupheader flex-sec justify-between item-center">
            <span className="pmsPopupheading clear-left10">
              Resend Intake: {intakeDetail && intakeDetail?.patStr}
            </span>
            <Button variant="circle" onClick={handleClose}>
              X
            </Button>
          </div>
          <div className="pmsPopupinnerBody intake-resnd-bdy">
            <div id="newPatientForm">
              <div className="pmsPopupinnerBodyrow margin0">
                <span className="pmsPopuplabel med-value bold">
                  Mobile:&nbsp;
                </span>
                <span className="value clear5">
                  {intakeDetail && intakeDetail?.mobile}
                </span>
              </div>
              <div className="pmsPopupinnerBodyrow margin0">
                <span className="pmsPopuplabel med-value bold">
                  Email:&nbsp;
                </span>
                <span className="value clear5">
                  {intakeDetail && intakeDetail?.email}
                </span>
              </div>
              <div className="pmsPopupinnerBodyrow margin0">
                <span className="pmsPopuplabel med-value bold width100 left">
                  Sent Forms:
                </span>
                <span className="value clear5">
                  {intakeDetail &&
                    intakeDetail?.forms &&
                    intakeDetail?.forms.map((item, i) => (
                      <span className="intake-dtl-form-lvl">{`${
                        i + 1
                      }. ${item}`}</span>
                    ))}
                </span>
              </div>
            </div>
          </div>

          <div className="width100 intake-resend-footer">
            <Button variant="outline" onClick={handleClose}>
              Close
            </Button>
            <Button
              variant="primary"
              onClick={() =>
                handleIntakeResend(intakeDetail?.id, intakeDetail?.patient_id)
              }
            >
              Send
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntakeResendPop;
